<template>
	<div class="c-aviation-calculator__tab-panels c-form">
		<div id="landing" class="c-aviation-calculator__tab-panel js-tab-control__panel always-open">
			<div class="c-aviation-charges">
				<div class="c-aviation-charges__type">
					<select name="aircraft-type"
							id="aircraft-type"
							v-model="selectedAircraftId">
						<option value="" disabled>Select Aircraft Type</option>
						<option v-for="item in aviationCharges" :key="item.id" :value="item.id">
							{{ item.label }}
						</option>
					</select>
				</div>

				<div class="c-aviation-charges__unit">
					<input name="mcTow_Air"
						   id="mcTow_Air"
						   placeholder="MCTOW (kg)"
						   type="number"
						   v-model.number="unitInput"
						   min="0"
						   step="100" />
				</div>

				<div class="c-aviation-charges__result">
					Rate per landing: <span v-if="CalculateRateAir !== null">${{ CalculateRateAir.toFixed(2) }}</span>
				</div>
			</div>
		</div>

		<div id="parking" class="c-aviation-calculator__tab-panel js-tab-control__panel" hidden>
			<div class="c-aviation-calculator__parking-block">
				<label name="arrival-date">Arrival Date</label>
				<DatePicker class="c-aviation-calculator__parking-date c-aviation-calculator__parking-input" v-model:value="arrival_date" id="arrival-date" placeholder="Arrival Date" />
				<select name="arrival-hour" class="c-aviation-calculator__parking-input" v-model="arrivaldatehour">
					<option value="">HR</option>
					<option v-for="h in hourArr" :key="h.val" :value="h.val">{{ h.txt }}</option>
				</select>
				<select name="arrival-minute" class="c-aviation-calculator__parking-input" v-model="arrivaldateminute">
					<option value="">MIN</option>
					<option v-for="m in minArr" :key="m.val" :value="m.val">{{ m.txt }}</option>
				</select>
			</div>

			<div class="c-aviation-calculator__parking-block">
				<label name="departure-date">Departure Date</label>
				<DatePicker class="c-aviation-calculator__parking-date c-aviation-calculator__parking-input" v-model:value="departure_date" id="departure-date"  placeholder="Departure Date"/>
				<select name="departure-hour" class="c-aviation-calculator__parking-input" v-model="departuredatehour">
					<option value="">HR</option>
					<option v-for="h in hourArr" :key="h.val" :value="h.val">{{ h.txt }}</option>
				</select>
				<select name="departure-minute" class="c-aviation-calculator__parking-input" v-model="departuredateminute">
					<option value="">MIN</option>
					<option v-for="m in minArr" :key="m.val" :value="m.val">{{ m.txt }}</option>
				</select>
			</div>

			<div class="c-aviation-calculator__parking-block">
				<input class="c-aviation-calculator__parking-weight c-aviation-calculator__parking-input" type="number" name="mcTow_Parking" id="mcTow_Parking" min="0" placeholder="MCTOW (kg)" v-model="mcTow_Parking">
			</div>

			<button class="c-aviation-calculator__parking-submit" @click="CalculateRateParking">Calculate Apron Parking</button>

			<p class="validation-summary-errors" v-if="mctowNotProvided_Parking" v-cloak>MCTOW (kg) is required. </p>
			<p class="validation-summary-errors" v-if="mctowNotValid_Parking" v-cloak>MCTOW (kg) should be greater than 0.</p>

			<div class="c-aviation-calculator__parking-result" v-if="showComputedData_Parking">
				<strong>{{ computedRate_Parking_text }}</strong>
			</div>
		</div>
	</div>

</template>

<script>
	import DatePicker from "Node/vue-datepicker-next";
	import jsonData from 'Vue/aviationCalculator.json';

	export default {
		name: "aviationcalculator",
		components: {
			DatePicker
		},

		delimiters: ["${", "}"],
		data() {
			return {
				aviationCharges: jsonData,
				selectedAircraftId: '',
				unitInput: '',
				mcTow_Air: null,
				mcTow_Parking: null,
				computedRate_Air: 0,
				computedRate_Parking: 0,
				computedRate_Parking_text: "",
				showComputedData_Air: false,
				showComputedData_Parking: false,
				typeNotSelected: false,
				mctowNotProvided_Air: false,
				mctowNotProvided_Parking: false,
				mctowNotValid_Air: false,
				mctowNotValid_Parking: false,
				arrival_date: null,
				departure_date: null,
				arrivaldatehour: "",
				arrivaldateminute: "",
				departuredatehour: "",
				departuredateminute: "",
				hourArr: Array.from({ length: 24 }, (v, i) => ({ val: i, txt: String(i).padStart(2, "0") })),
				minArr: [0, 10, 20, 30, 40, 50].map((val) => ({ val, txt: String(val).padStart(2, "0") })),
			};
		},
		computed: {
			CalculateRateAir() {
				if (!this.selectedAircraftId || this.unitInput === '' || isNaN(this.unitInput)) return null;

				const aircraft = this.aviationCharges.find(aircraft => aircraft.id === this.selectedAircraftId);

				if (!aircraft || !Array.isArray(aircraft.charges)) return null;

				const match = aircraft.charges.find(chargeRate =>
					this.unitInput >= chargeRate.minWeightKg &&
					(chargeRate.maxWeightKg === null || this.unitInput <= chargeRate.maxWeightKg)
				);

				return match ? match.ratePerLanding : null;

			},
		},
		methods: {
			CalculateRateParking() {
				this.showComputedData_Parking = false;
				this.mctowNotProvided_Parking = false;
				this.mctowNotValid_Parking = false;
				if (!this.arrival_date) {
					alert("Provide Arrival Date");
					return;
				}
				if (!this.departure_date) {
					alert("Provide Departure Date");
					return;
				}

				// Use getFullYear instead of getYear
				const t = new Date(
					this.arrival_date.getFullYear(),
					this.arrival_date.getMonth(),
					this.arrival_date.getDate()
				);
				const n = new Date(
					this.departure_date.getFullYear(),
					this.departure_date.getMonth(),
					this.departure_date.getDate()
				);
				if (n < t) {
					alert("Departure day can not be earlier than arrival day");
					return;
				}
				let r = Math.abs(Math.round((n - t) / 86400000)); // 86400000 ms in a day
				const i =
					60 * parseInt(this.arrivaldatehour || "0") + parseInt(this.arrivaldateminute || "0");
				const a =
					60 * parseInt(this.departuredatehour || "0") + parseInt(this.departuredateminute || "0");

				let o = false;
				if (r === 0 && i > a) {
					alert("Departure time can not be earlier than arrival time");
					return;
				}

				if (this.mcTow_Parking != null && this.mcTow_Parking !== "") {
					if (this.mcTow_Parking < 0) {
						this.mctowNotValid_Parking = true;
						return;
					}
					const s = parseInt(this.mcTow_Parking);
					if (r === 0 && i >= 900) o = true;
					if (r === 1 && i >= 900 && a <= 600) o = true;
					let l = a - i;
					if (l < 0) {
						l = 1440 + l;
						r -= 1;
					}
					const c = Math.floor(l / 60) || 0;
					l = l - 60 * c || 0;
					const u = this.CalcFees(r, c, l, o, s);
					this.showComputedData_Parking = true;
					this.computedRate_Parking_text = `To park for ${r} days ${c} hours ${l} minutes, your fee will be $${u}`;
				} else {
					this.mctowNotProvided_Parking = true;
				}
			},
			CalcFees(days, hours, mins, overnight, mtow) {
				if (hours > 0 || mins > 0) days += 1;
				let fee = 0;
				if (mtow > 0 && mtow <= 1500) fee = 20 * days;
				else if (mtow > 1500 && mtow <= 2000) fee = 30 * days;
				else if (mtow > 2000 && mtow <= 4000) fee = 55 * days;
				else if (mtow > 4000 && mtow <= 5700) fee = 90 * days;
				else if (mtow > 5700 && mtow <= 10000) fee = 250 * days;
				else if (mtow > 10000 && mtow <= 20000) fee = 500 * days;
				else if (mtow > 20000 && mtow <= 30000) fee = 1000 * days;
				else if (mtow > 30000) fee = 1500 * days;
				if (overnight) fee = 0;
				return fee;
			},
		},
	};
</script>

